<template>
  <span
    :class="
      cn(
        'tw:block tw:bg-gray-100 tw:animate-shimmer tw:motion-reduce:animate-none',
        variant === 'bar' && 'tw:rounded-md',
        variant === 'block' && 'tw:rounded-md',
        variant === 'circle' && 'tw:rounded-full',
        $attrs.class as string | undefined
      )
    "
    :style="sizeStyle"
    role="status"
    aria-hidden="true" />
</template>

<script setup lang="ts">
// LeadSkeleton — content-loading placeholder.
//
// Uses the shimmer keyframe transcribed from the OrdersRedesign design prototype's `.sk` class
// (opacity 0.45 → 0.9 → 0.45 over 1.4s). The animation is registered in tailwind.css as
// `--animate-shimmer` so any Tailwind `animate-shimmer` utility resolves to it.
import { computed, useAttrs } from 'vue';
import { cn } from '@/lib/cn';

defineOptions({ inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    /** Width — number is px, string is passed through (e.g. `"60%"`). */
    width?: number | string;
    /** Height — number is px, string is passed through. Defaults to `10px` (matches design prototype). */
    height?: number | string;
    /** `bar` and `block` are pill-corner rounded; `circle` is a round dot. */
    variant?: 'bar' | 'block' | 'circle';
  }>(),
  {
    width: undefined,
    height: 10,
    variant: 'bar',
  }
);

const attrs = useAttrs();
void attrs; // referenced via $attrs.class in the template

/* --------------------------------- COMPUTED ------------------------------- */

const sizeStyle = computed(() => {
  const toCss = (v: number | string | undefined) => (typeof v === 'number' ? `${v}px` : v);
  return {
    width: toCss(props.width),
    height: toCss(props.height),
  };
});
</script>
